module.exports = __webpack_public_path__ + "static/media/targeting-delivery.6f520cdf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/targeting-delivery.svg
// module id = 1324
// module chunks = 1